import { Component, ViewChild, EventEmitter } from '@angular/core';
import { App, Nav, Platform, Events } from 'ionic-angular';
import { Subscription } from 'rxjs/Subscription';
import { Auth } from '../providers/auth/auth';
import { ModalController, MenuController, AlertController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable'
import { Company } from '../models/company';
import { Sector } from '../models/sector';
import { Region } from '../models/region';
import { User } from '../models/user';
import { App as AppModel } from '../models/app.model';
import { Api } from '../providers/api/api';
import { Title } from '@angular/platform-browser';
// ngrx/store
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers'

// Actions
import * as CompanyAnalysisActions from '../actions/company-analysis.actions';
import * as user from '../actions/user.actions';
import * as companies from '../actions/companies.actions';
import * as platformActions from '../actions/platform.actions';

import { Slug } from 'ng2-slugify';

import { Subject } from 'rxjs/Subject';

export interface PageInterface {
  title: string;
  name: string;
  sidebar: string;
  icon: string;
  filtername?: string;
  component?: any;
  logsOut?: boolean;
  index?: number;
  tabName?: string;
  tabComponent?: any;
  reqAuth?: boolean;
  showOnMenu?: boolean;
}

@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  company: Observable<Company>;
  companyMeta: Observable<any>;
  user: Observable<User>;
  fuzzyResults: Observable<any>;
  filters: Observable<any[]>;
  config: Observable<object>;
  sectors: Observable<Sector[]>;
  regions: Observable<Region[]>;
  syntheticRegions: Observable<Region[]>;
  app: Observable<AppModel>;
  showCashflow: Observable<boolean>;
  comparison: Observable<any>;
  u: any;

  filterName: string = 'screens';
  filtersSubscription: Subscription;
  filter: any;

  @ViewChild(Nav) nav;
  loggedIn: boolean = false;
  isMobile: boolean = false;
  change: EventEmitter<string> = new EventEmitter<string>();
  companyPage: boolean = false;
  sideSearchTerm: string;
  sideSearching: boolean = false;
  sidebar: any;
  _sidebar: string;

  homePage: PageInterface =
    { title: 'Home', name: 'HomePage', component: 'HomePage', index: 1, icon: 'home', sidebar: 'home', reqAuth: true };

  Pages: PageInterface[] = [
    { title: 'Home', name: 'HomePage', component: 'HomePage', index: 1, icon: 'md-home', sidebar: 'home', logsOut: false, showOnMenu: true, reqAuth: true },
    { title: 'Screens', filtername: 'all', name: 'ScreensPage', component: 'Screens', index: 1, icon: 'md-eye', sidebar: 'screens', logsOut: false, showOnMenu: true, reqAuth: true },
    { title: 'WatchLists', filtername: 'personal', name: 'WatchListsPage', component: 'WatchLists', index: 1, icon: 'md-eye', sidebar: 'watchlists', logsOut: false, showOnMenu: true, reqAuth: true },
    { title: 'Coverage', name: 'CoveragePage', component: 'Coverage', index: 1, icon: 'md-eye', sidebar: 'coverage', logsOut: false, showOnMenu: true, reqAuth: true },
    { title: 'Legal', name: 'LegalPage', component: 'LegalPage', index: 1, icon: 'document', sidebar: 'home', showOnMenu: true, reqAuth: true },
    { title: 'Compare', name: 'CompanyComparisonPage', component: 'CompanyComparisonPage', index: 1, icon: 'document', sidebar: 'home', showOnMenu: true, reqAuth: true },
    { title: 'Contact', name: 'ContactPage', component: 'ContactPage', index: 0, icon: 'people', sidebar: 'home', showOnMenu: true, reqAuth: true },
    { title: 'User Guide', name: 'UserGuidePage', component: 'UserGuidePage', icon: 'help', sidebar: 'home', showOnMenu: true, reqAuth: true },
    { title: 'Definitions', name: 'DefinitionsPage', component: 'DefinitionsPage', icon: 'help', sidebar: 'home', showOnMenu: true, reqAuth: true },
    { title: 'Login', name: 'LoginPage', component: 'LoginPage', index: 1, icon: 'log-in', sidebar: undefined, showOnMenu: false, reqAuth: true, logsOut: true },
    // { title: 'Account', name: 'AccountPage', component: 'ContactPage', icon: 'person' },
    { title: 'Logout', name: 'TabsPage', component: 'ContactPage', icon: 'log-out', sidebar: undefined, logsOut: true, reqAuth: true },
  ];
  rootPage: any = 'HomePage';
  subscription: Subscription;
  searchedFor: Observable<string>;

  //Initialise slugify with default params
  slug = new Slug('default');
  pageTitle: string = '';
  constructor(
    public api: Api,
    public store: Store<fromRoot.State>,
    public appCtrl: App,
    public alertCtrl: AlertController,
    public menu: MenuController,
    public modalCtrl: ModalController,
    public authProvider: Auth,
    public platform: Platform,
    public events: Events,
    public title: Title,
  ) {

    this.filter = new Subject();
    this.sidebar = new Subject();

    this.fuzzyResults = this.store.select(fromRoot.getFuzzyResults);
    this.company = this.store.select(fromRoot.getCompany);
    this.companyMeta = this.store.select(fromRoot.getCompanyMeta);
    this.user = this.store.select(fromRoot.getUser);
    this.filters = this.store.select(fromRoot.getFilters);
    this.sectors = this.store.select(fromRoot.getSectors);
    this.regions = this.store.select(fromRoot.getRegions);
    this.syntheticRegions = this.store.select(fromRoot.getSyntheticRegions);
    this.app = this.store.select(fromRoot.getApp);
    this.showCashflow = this.store.select(fromRoot.getShowCashflow);
    this.comparison = this.store.select(fromRoot.getComparison);

    let subscription = this.user
      .first(u => !!u._id)
      .subscribe(val => {
        this.u = val;
        this.store.dispatch(new user.FetchFilters(this.u._id));
        // this.store.dispatch(new user.ClearFilter());
        //subscription.unsubscribe();
      },
      err => {
        console.error('Error fetching user subscription:', err);
      });

    platform.ready().then(() => {
      this.isMobile = this.platform.is('mobile');
    });

    this.authProvider.authUser.subscribe(jwt => {
      if (jwt) {
        // this.rootPage = 'HomePage';
        this.loggedIn = true;
        this.store.dispatch(new platformActions.FetchPlatformInfo());

        //Fetching companies
        console.log('Fetching companies');

        this.store.dispatch(new companies.Fetch({}));

      }
      else {
        this.loggedIn = false;
        this.setSidebar('login');
        this.rootPage = 'LoginPage';
      }

    });

    this.authProvider.checkLogin();

    this.events.subscribe('openPage', (pageName, params: any = {}) => {
      this.openPageByName(pageName, params);
    });

    this.initializeEventHandlers();

  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.filtersSubscription.unsubscribe();
  }

  getActiveFilter(filterref) {
    if (!filterref) return;
    if (this.filtersSubscription) this.filtersSubscription.unsubscribe();

    this.filtersSubscription = this.filters.filter(f => f.length != 0).take(1).subscribe(filters => {
      let _filter = filters.find(f => f.ref == filterref) || undefined;
      if (_filter) this.filter.next(_filter);
    });

  }

  private initializeEventHandlers() {

    this.events.subscribe('createFilter', filter => {
      this.createFilter(filter);
    })

    this.events.subscribe('updateFilter', filter => {
      this.updateFilter(filter);
    });

    this.events.subscribe('setActiveFilterName', filterref => {
      this.getActiveFilter(filterref);
    });

    this.events.subscribe('companyPage:load', (res) => {
      this.sideSearching = false;
      this.sideSearchTerm = '';
      this.companyPage = true;
      this.setSidebar('company');

    });

    this.events.subscribe('companyPage:unload', () => {
      this.sideSearching = false;
      this.sideSearchTerm = '';
      this.companyPage = false;
      this.setSidebar('home');
    });

    this.events.subscribe('openSidebar', (sidebar) => {
      this.setSidebar(sidebar);
      // setTimeout(() => { this.sidebar = sidebar }, 1000);
    });

  }

  presentLoginPage() {
    this.nav.setRoot('LoginPage');
  }

  goHome() {
    this.nav.setRoot('HomePage');
  }

  openPageByName(pageName: string, params: any) {
    let page: PageInterface = this.Pages.filter(p => p.name === pageName)[0];
    this.openPage(page, params)
  }

  openPage(page: PageInterface, params: any = {}) {

    this.title.setTitle('Willis Welby');

    if (page.logsOut === true) {
      // Give the menu time to close before changing to logged out
      // this.userData.logout();
      this.logout().then(() => {

      }, () => { });
      return;
    } else {

      //If the page requires auth, then check and go to login page if necessessary
      if (page.reqAuth && !this.loggedIn) { this.nav.setRoot('LoginPage'); return; }

      // the nav component was found using @ViewChild(Nav)
      // setRoot on the nav to remove previous pages and only have this page
      // we wouldn't want the back button to show in this scenario
      if (page.index) {
        params = Object.assign({ tabIndex: page.index }, params);
      }


      // If we are already on tabs just change the selected tab
      // don't setRoot again, this maintains the history stack of the
      // tabs even if changing them from the menu
      if (this.nav.getActiveChildNavs().length && page.index != undefined) {
        this.nav.getActiveChildNavs()[0].select(page.index);
        // Set the root of the nav with params if it's a tab index
      } else {
        this.nav.setRoot(page.name, params).catch((err: any) => {
          console.error(`Didn't set nav root: ${err}`);
          return;
        });
        this.sidebar.next(page.sidebar || 'home');
        this.filterName = params.filtername;
      }
    }


  }

  isActive(page: PageInterface) {
    let childNav = this.nav.getActiveChildNavs()[0];

    // Tabs are a special case because they have their own navigation
    if (childNav) {
      if (childNav.getSelected() && childNav.getSelected().root === page.tabComponent) {
        return 'yellow';
      }
      return;
    }

    if (this.nav.getActive() && this.nav.getActive().name === page.name) {
      return 'yellow';
    }
    return;
  }

  logout() {
    return new Promise((resolve, reject) => {

      this.authProvider.logout();
      this.change.emit('LoginPage');
      resolve();
    });
  }

  onSideSearchInput(searchText) {
    this.sideSearching = this.sideSearchTerm.length > 0 ? true : false;
    this.store.dispatch(new companies.FuzzyFetch(this.sideSearchTerm));
    // this.store.dispatch( new SEARCH() );

    // { type: SEARCH, payload: this.sideSearchTerm});

  }
  onSideSearchCancel() {
    this.sideSearchTerm = null;
    // this.store.dispatch({ type: RESET });
  }

  goToCompany(ticker) {
    this.nav.push('CompanyContainerPage', { ticker });
  }

  setSidebar(val) {
    this.sidebar.next(Observable.of(val));
    this._sidebar = val;
  }

  deleteFilter(filter) {
    filter.ref = filter.ref || this.slug.slugify(filter.name);
    this.store.dispatch(new user.DeleteFilter({ user_id: this.u._id, filter: filter }));
    this.openPageByName('HomePage', {});
  }


  createFilter(filter) {
    this.store.dispatch(new user.CreateFilter(filter));
  }

  updateFilter(filter) {
  }

  mapFilterForMongo(f) {
    let filter = JSON.parse(JSON.stringify(f));
    delete filter.ebitm;
    delete filter.id;
    delete filter.name;
    return filter;
  }

  goToCoverageSection(section) {
    //options are sectors | regions | statistics
    this.nav.setRoot('CoveragePage', { section: section || 'sectors' })
  }

  shouldShowMenu() {
    switch (this._sidebar) {
      case "home":
        return false;
      default:
        return true
    }
  }
  
  /**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
  detectIE() {
    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // IE 12 / Spartan
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge (IE 12+)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts